import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';

import GenericModal from '../../../../../../containers/modal/generic_modal';
import {asFragment} from '../../../../../../relay-helpers/TSRelayConverter';
import {notNullishAndPredicate} from '../../../../util/NotNullPredicate';
import OwnedProjectRow from './OwnedProjectRow';

import type {OwnedProjectsModal_viewer} from './__generated__/OwnedProjectsModal_viewer.graphql';
import type {OwnedProjectRow_project} from './__generated__/OwnedProjectRow_project.graphql';
interface OwnedProjectsModalProps {
	viewer: OwnedProjectsModal_viewer;
	closeModal: () => void;
}

const OwnedProjectsModal = ({viewer, closeModal}: OwnedProjectsModalProps) => {
	const content = viewer.projects?.edges
		?.filter(notNullishAndPredicate(project => !!project.node?.userIsProjectOwner))
		.map(project => {
			return <OwnedProjectRow key={project.node?.id} project={asFragment<OwnedProjectRow_project>(project.node)} />;
		});
	return <GenericModal closeModal={closeModal} headerText={'Owned Projects'} content={content} />;
};

const OwnedProjectsModalQuery = graphql`
	query OwnedProjectsModal_Query {
		viewer {
			actualPersonId
			component(name: "create_project_modal")
			...OwnedProjectsModal_viewer
		}
	}
`;

export {OwnedProjectsModalQuery};

export default createFragmentContainer(OwnedProjectsModal, {
	viewer: graphql`
		fragment OwnedProjectsModal_viewer on Viewer {
			projects(first: 1000000) @connection(key: "Viewer_projects", filters: []) {
				edges {
					node {
						id
						userIsProjectOwner
						...OwnedProjectRow_project
					}
				}
			}
		}
	`,
});
